import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import Button from 'src/shared/components/Button'

import { Container, Title, StatsWrapper, StatItem, StatValue, StatLabel } from './styles'

export const Metrics = () => {
  const [hasAnimated, setHasAnimated] = useState(false)
  const [animatedValues, setAnimatedValues] = useState([0, 0, 0])
  const containerRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  const stats = [
    { value: 350, label: 'Constructoras', prefix: '+', suffix: '' },
    { value: 150, label: 'Millones en cotizaciones', prefix: '+$', suffix: 'M' },
    { value: 3.5, label: 'Entregas Exitosas', prefix: '+', suffix: 'K' },
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true)
          startCount()
        }
      },
      { threshold: 0.1 }
    )

    if (containerRef.current) observer.observe(containerRef.current)

    return () => observer.disconnect()
  }, [hasAnimated])

  const startCount = () => {
    const duration = 1500
    const frameDuration = 1000 / 60
    const totalFrames = Math.round(duration / frameDuration)

    stats.forEach((stat, index) => {
      let frame = 0

      const counter = () => {
        frame++
        const progress = Math.min(frame / totalFrames, 1)
        const current = stat.value * progress

        setAnimatedValues((prev) => {
          const updated = [...prev]
          updated[index] = parseFloat(current.toFixed(stat.value < 10 ? 1 : 0))
          return updated
        })

        if (frame < totalFrames) {
          requestAnimationFrame(counter)
        }
      }

      requestAnimationFrame(counter)
    })
  }

  return (
    <Container ref={containerRef}>
      <Title>Nuestro Impacto</Title>
      <StatsWrapper>
        {stats.map((stat, index) => (
          <StatItem key={index}>
            <StatValue>
              {stat.prefix}
              {stat.value < 10
                ? animatedValues[index].toFixed(1)
                : Math.round(animatedValues[index])}
              {stat.suffix}
            </StatValue>
            <StatLabel>{stat.label}</StatLabel>
          </StatItem>
        ))}
      </StatsWrapper>
      <div style={{ paddingBottom: 50 }}>
        <Button
          equip="degraded"
          size="large"
          style={{ width: '200px', paddingBlock: 24 }}
          onClick={() => {
            navigate('/aboutus')
          }}
        >
          Ver más
        </Button>
      </div>
    </Container>
  )
}
